<template>
  <div id="app">
    <!-- 桌面端：全局包裹DesktopLayout -->
    <DesktopLayout v-if="!isMobile && !useSelfLayout" :show-page-header="false">
      <RouterView v-slot="{ Component }">
        <keep-alive :include="['OrderListPage', 'AccountMarketPage']">
          <component :is="Component" />
        </keep-alive>
      </RouterView>
    </DesktopLayout>

    <!-- 移动端：全局包裹MobileLayout -->
    <MobileLayout v-else-if="isMobile && !useSelfLayout" :show-nav-bar="showNavBar" :show-tab-bar="showTabBar" :nav-title="navTitle" :show-back="showBack" :show-logo="showLogo">
      <RouterView v-slot="{ Component }">
        <keep-alive :include="['OrderListPage', 'AccountMarketPage']">
          <component :is="Component" />
        </keep-alive>
      </RouterView>
    </MobileLayout>

    <!-- 自带Layout的页面：直接渲染 -->
    <RouterView v-else v-slot="{ Component }">
      <keep-alive :include="['OrderListPage', 'AccountMarketPage']">
        <component :is="Component" />
      </keep-alive>
    </RouterView>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { RouterView, useRoute } from "vue-router";
import { useResponsive } from "@/composables";
import { DesktopLayout, MobileLayout } from "@/layouts";

const { isMobile } = useResponsive();
const route = useRoute();

// 检查当前路由是否使用自带的Layout
const useSelfLayout = computed(() => {
  return route.meta.useSelfLayout === true;
});

// 移动端NavBar和TabBar配置（从路由meta读取）
const showNavBar = computed(() => {
  // 默认显示NavBar，除非明确设置为false
  return true;
});

const showTabBar = computed(() => {
  // TabBar根据路由meta的showBottomNav配置显示
  return route.meta.showBottomNav === true;
});

const navTitle = computed(() => {
  return (route.meta.mobileTitle as string) || "";
});

const showBack = computed(() => {
  return false;
});

const showLogo = computed(() => {
  // 首页显示logo
  return true;
});
</script>

<style scoped>
#app {
  font-family:
    "Inter",
    -apple-system,
    BlinkMacSystemFont,
    "Segoe UI",
    "Roboto",
    "Oxygen",
    "Ubuntu",
    "Cantarell",
    "Fira Sans",
    "Droid Sans",
    "Helvetica Neue",
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  margin: 0;
  padding: 0;
  min-height: 100vh;
  background: transparent;
}
</style>
